import { HttpClient, HttpContext, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { ApiError } from '../../models/api/api-error.model';
import { AuditModel, Timing } from '../../models/api/audit.model';
import { IS_PUBLIC_API } from '../../utils/is-public-api- context';
import { CustomHttpParams } from '../custom-http-params.class';

declare const require: any;

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private version: string = require('../../../../../package.json').version;
  constructor(private http: HttpClient) {}

  sendAudit(data: AuditModel) {
    const url = `${environment.apiBase}/mortgage/frontaudit/${environment.api_version.audit}/audit/save/mortgage`;
    this.http
      .post(url, data, {
        params: new CustomHttpParams(false),
        context: new HttpContext().set(IS_PUBLIC_API, true),
      })
      .subscribe();
  }

  private mapperAudit(request: HttpRequest<any>, timing: Timing): AuditModel {
    const caseId = sessionStorage.getItem('caseId');
    return {
      headers: this.arrayToObject(request.headers),
      method: request.method,
      requestTime: timing.requestTime,
      responseTime: timing.responseTime,
      position: location.href,
      text: '',
      channel: 'web',
      version: this.version,
      urlString: request.url,
      body: request.body ? JSON.stringify(request.body) : '',
      response: '',
      stateTrace: '',
      apiError: '',
      caseId: caseId ? atob(caseId) : '',
    };
  }

  mapperAuditError(
    request: HttpRequest<any>,
    error: ApiError,
    timing: Timing,
  ): AuditModel {
    return {
      ...this.mapperAudit(request, timing),
      ...{ apiError: JSON.stringify(error), stateTrace: 'KO' },
    };
  }

  mapperAuditData(request: HttpRequest<any>, data: unknown, timing: Timing): AuditModel {
    return {
      ...this.mapperAudit(request, timing),
      ...{ response: data ? JSON.stringify(data) : '', stateTrace: 'OK' },
    };
  }

  private arrayToObject(data: HttpHeaders) {
    const keys = data.keys();
    const dataObj: any = {};
    if (keys.length > 0) {
      keys.forEach((key) => {
        dataObj[key] = key !== 'Authorization' ? data.get(key) : '';
      });
      return JSON.stringify(dataObj);
    }
    return '';
  }
}
